import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-2.4 -2.4 28.80 28.80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	transform: "rotate(90)",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_iconCarrier",
			children: /* @__PURE__ */ _jsx("path", { d: "M5.28033 14.341C4.57585 13.5082 4.22361 13.0918 4.08901 12.627C3.97033 12.2172 3.97033 11.7828 4.08901 11.373C4.22361 10.9082 4.57585 10.4918 5.28032 9.65904L9.1484 5.08645C10.1277 3.9288 10.6173 3.34997 11.2036 3.13889C11.7179 2.9537 12.2821 2.9537 12.7964 3.13889C13.3827 3.34997 13.8723 3.9288 14.8516 5.08645L18.7197 9.65904C19.4242 10.4918 19.7764 10.9082 19.911 11.373C20.0297 11.7828 20.0297 12.2172 19.911 12.627C19.7764 13.0918 19.4242 13.5082 18.7197 14.341L14.8516 18.9135C13.8723 20.0712 13.3827 20.65 12.7964 20.8611C12.2821 21.0463 11.7179 21.0463 11.2036 20.8611C10.6173 20.65 10.1277 20.0712 9.1484 18.9135L5.28033 14.341Z" })
		})
	]
});
export default SvgRepeat;
